<!--判断题-->
<template>
  <div class="Judge">
    <el-form-item label="题目" required>
        <uEditor :content="formData.subject" ref="subject" @getUEditorContent="getUEditorSubjectContent"></uEditor>
    </el-form-item>
    <el-form-item label="答案" required>
        <el-radio v-model="formData.finalanswer" label="T">正确</el-radio>
        <el-radio v-model="formData.finalanswer" label="F">错误</el-radio>
    </el-form-item>
    <el-form-item label="试题分析">
        <uEditor :content="formData.quesanalysis" ref="quesanalysis" @getUEditorContent="getUEditorQuesanalysisContent"></uEditor>
    </el-form-item>
    <el-form-item>
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="submit">保存</el-button>
    </el-form-item>
  </div>
</template>

<script>
import UEditor from 'base/uEditor/uEditor4'
export default {
  name: 'Judge',
  props: ['formData'],
  data () {
    return {
        form: {
            subject: '',   // 试题题干Html
            quesanalysis: '', // 试题解析
            finalanswer: 'T' // 填空、判断有效 1、对于判断题，答案记录为T或者F，用户提交也提交T或者F，直接对比 2、对于填空题，各个空之间以|分隔，每空有多答案以分号分隔，如果答案中含有|和分号，都替换成逗号，前端组装后提交
        },
    }
  },
  mounted () {
        if (!this.$route.query.innerid) {
            // 非编辑情况下
            // this._initRadio()
            this.formData.finalanswer = this.form.finalanswer
        }
  },
  methods: {
    getUEditorSubjectContent(content) { // 编辑器题目
        this.formData.subject = content
    },
    getUEditorQuesanalysisContent(content) {   // 解析
        this.formData.quesanalysis = content
    },
    cancel() {  // 返回题库
        this.$emit('cancel')
    },
    submit() {
        if (this.formData.finalanswer == '') {
            this.$message.error('答案不能为空')
            return
        }
        // 传数据给父元素
        this.$emit('childSubmitFormApi', JSON.stringify(this.formData))
    }
  },
  filters: {},
  watch: {},
  computed: {},
  components: {
      UEditor
  }
}
</script>

<style lang="scss" type="text/scss" scope>
.Judge {
    .uEditor {
        .ue_btn {
            display: none;
        }
    }
    .del {
        position: absolute;
        top: 0;
        right: -20px;
        cursor: pointer;
        img {
            width: 12px;
            height: 12px;
        }
    }
}
</style>
